"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AdConnectorGreyMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__ad-connector-grey-multitone-filled__clip0_19343_5317)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9ECEF",
    d: "M13.951.25c1.087 0 1.964.877 1.964 1.964v11.528a1.962 1.962 0 01-1.964 1.964H2.42a1.962 1.962 0 01-1.964-1.964L13.95.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED4DA",
    d: "M15.915 2.214L2.42 15.71a1.962 1.962 0 01-1.964-1.964V2.214C.455 1.13 1.336.25 2.419.25h11.528c1.087 0 1.964.877 1.964 1.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.273 7.547H8.187v.805h3.086v-.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.35 11.778h-.804V4.364h.805v7.414zM13.082 5.361a.716.716 0 100-1.433.716.716 0 000 1.433zM13.082 8.666a.716.716 0 100-1.433.716.716 0 000 1.433zM13.082 11.97a.717.717 0 100-1.432.717.717 0 000 1.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M3.101 3.125v9.75h4.601v-9.75h-4.6zm-.139-1h4.879c.476 0 .861.386.861.862v10.026a.861.861 0 01-.861.862H2.962a.861.861 0 01-.86-.862V2.987c0-.476.385-.862.86-.862z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M13.867 16H2.129A2.133 2.133 0 010 13.87V2.13C0 .957.954 0 2.13 0h11.737c1.175 0 2.129.958 2.129 2.13v11.737c0 1.175-.958 2.129-2.13 2.129V16zM2.129.805c-.732 0-1.324.596-1.324 1.324v11.738c0 .732.596 1.324 1.324 1.324h11.738c.732 0 1.324-.596 1.324-1.324V2.129c0-.732-.596-1.324-1.324-1.324H2.129z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M5.398 4.025c-1.03 0-1.86.833-1.86 1.86 0 .74.43 1.388 1.063 1.682v3.687l.519.508a.377.377 0 00.547-.017l.451-.49v-.584h-.342v-.367h.342V9.93h-.25v-.266h.25V9.29h-.072a.277.277 0 01-.274-.274c0-.149.125-.273.274-.273h.072v-1.14a1.865 1.865 0 00-.72-3.582v.004zm-.037.62a.63.63 0 01.628.632.63.63 0 11-1.26 0c0-.35.278-.632.632-.632z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__ad-connector-grey-multitone-filled__clip0_19343_5317"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

AdConnectorGreyMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AdConnectorGreyMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AdConnectorGreyMultitoneFilled;
exports["default"] = _default;